import React, { useState, useEffect } from "react";
import TableProduct from "../../../../components/lists/productList/index";
import MenuAdmin from '../../../../components/layout/menu';
import ResetFiltersButton from "../../../../components/filters/resetFiltersButton/index";
import FilterButton from "../../../../components/filters/filterButton/index";
import FilterInput from "../../../../components/filters/filterInput/index";
import SearchInput from "../../../../components/filters/searchInput/index";
import ExportButton from "../../../../components/shared/exportButton";
import { getProducts } from  '../../../../client/administration/products/index';
import { getProductsCategory } from '../../../../client/administration/products/productCategory/index';
import * as XLSX from 'xlsx'; 
import {  RiAddFill } from "react-icons/ri";
import ContentLoader from 'react-content-loader'; // Importamos el ContentLoader
import Programate from "../../../../components/layout/footer";

export default function Product({ }) {
  const [currentRecordsCount, setCurrentRecordsCount] = useState(10);
  const [currentPage, setCurrentPage] = useState(1); 
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true); // Estado de carga

  const [showModalAddProduct, setShowModalAddProduct] = useState(false);

  const openModalAddProduct = () => {
    setShowModalAddProduct(true);
  };

  const closeModalAddProduct = () => {
    setShowModalAddProduct(false);
  };
  
  //menu
  const [isMenuOpen, setIsMenuOpen] = useState(false); 
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
 
  const handleRecordsCountChange = (event) => {
    const newCount = parseInt(event.target.value, 10);
    setCurrentRecordsCount(newCount); 
    setCurrentPage(1); 
  };

  /** FILTRAR POR CATEGORIA */
  const [categoria, setCategoria] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const handleFilterByCategoria = (category) => {
    setSelectedCategory(category);
    const filtered = records.filter(record => record.productCategory?.categoryName && record.productCategory.categoryName.includes(category));
    setFilteredRecords(filtered);
  };

  /** FILTRAR POR PRODUCTO */
  const [product, setProduct] = useState("");
  const handleFilterByProduct = (value) => {
    console.log("Valor de producto ingresado:", value);
    setProduct(value);
    const filtered = records.filter(record => 
      record.productName && 
      record.productName.toLowerCase().includes(value.toLowerCase())
    );
    console.log("Registros filtrados:", filtered);
    setFilteredRecords(filtered);
  };

  /** FILTRAR POR CODIGO */
  const [codeProduct, setCodeProduct] = useState("");

  const fetchCategoria = async () => {
    try {
      const response = await getProductsCategory();
      console.log("Datos recibidos:", response.data); 
      setRecords(response.data);
      setFilteredRecords(response.data);
      const uniqueCategory = [...new Set(response.data.map(record => record.categoryName))];
      setCategoria(uniqueCategory);
    } catch (error) {
      console.error('Error fetching visits:', error);
    } finally {
      setLoading(false); // Detener el loading después de obtener los datos
    }
  };
  
  useEffect(() => {
    fetchCategoria(); 
  }, []);

  console.log("categorias", categoria)

  const isExportDisabled = filteredRecords.length === 0;

  const fetchProductos = async () => {
    try {
      const response = await getProducts();
      console.log("Datos de productos:", response.data);
      setRecords(response.data); 
      setFilteredRecords(response.data); 
    } catch (error) {
      console.error("Error al obtener productos:", error);
    } finally {
      setLoading(false); // Detener el loading después de obtener los datos
    }
  };
  useEffect(() => {
    fetchProductos(); 
  }, []);
  
  const handleExportToExcel = () => {
    const exportData = filteredRecords.map(record => ({
      id: record.id,
      Producto: record.productName,
      Codigo: record.codeProduct,
      Categoria: record.productCategory.categoryName,
      FechaRegistro: new Date(record.createdAt).toLocaleString()
    }));
  
    const ws = XLSX.utils.json_to_sheet(exportData);

    ws['A1'].v = 'ID';
    ws['B1'].v = 'Producto';
    ws['C1'].v = 'Código';
    ws['D1'].v = 'Categoría';
    ws['E1'].v = 'Fecha Registro';
  
    //  ancho de las columnas
    ws['!cols'] = [
      { wch: 10 }, //  (ID)
      { wch: 20 }, //  (Producto)
      { wch: 15 }, //  (Código)
      { wch: 20 }, //  (Categoria)
      { wch: 25 }  //  (Fecha Registro)
    ];
  
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Productos");
    XLSX.writeFile(wb, "productos.xlsx");
  };

  const handleResetFilters = () => {
    setCodeProduct("");
    setProduct("");
    setSelectedCategory(""); 
    setSearchTerm("");
    setFilteredRecords(records); 
  };

  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (value) => {
    setSearchTerm(value); 
    const lowerCaseValue = value.toLowerCase(); 
  
    const filtered = records.filter(record => {
      const codeMatches = record.productName  && record.productName.toLowerCase().includes(lowerCaseValue);
      const productMatches = record.codeProduct && record.codeProduct.toLowerCase().includes(lowerCaseValue);
      const categoryNameMatches = record.productCategory?.categoryName && record.productCategory.categoryName.toString().includes(value);
  
      return codeMatches || productMatches || categoryNameMatches;
    });
  
    setFilteredRecords(filtered);
  };

  return (
    <div className='flex w-full min-h-screen'>
      <MenuAdmin isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 transition-all  duration-300 ml-0 ${isMenuOpen ? "lg:ml-[220px] sm:ml-[0] md:ml-[0] " : "ml-0 "} w-[83%]`}>   
        <div className="flex flex-col min-h-screen justify-between">
          <div className="px-[3%] pb-12">
            {loading ? (
              <div className="pb-8 pt-32 sm:-space-y-20 -space-y-2">
                {/* Skeleton para el título */}
                <ContentLoader
                  viewBox="0 0 1200 200" 
                  height={"100%"} 
                  width={"100%"}
                  backgroundColor="#f3f3f3" 
                  foregroundColor="#ecebeb" 
                  speed={5} 
                >
                  <rect x="0" y="0" width="200" height="40" rx="5" ry="5" /> {/* Título "Productos" */}
                  <rect x="0" y="60" width="230" height="40" rx="5" ry="5" /> {/* Filtro por producto */}
                  <rect x="245" y="60" width="280" height="40" rx="5" ry="5" /> {/* Filtro por categoría */}
                  <rect x="850" y="60" width="350" height="40" rx="5" ry="5" /> {/* Barra de búsqueda */}
                  <rect x="0" y="120" width="200" height="40" rx="5" ry="5" /> {/* Botón "Agregar producto" */}
                  <rect x="960" y="120" width="130" height="40" rx="5" ry="5" /> {/* Botón "Reset" */}
                  <rect x="1100" y="120" width="100" height="40" rx="5" ry="5" /> {/* Botón "Exportar" */}
                </ContentLoader>
    
                {/* Skeleton para la tabla */}
                <ContentLoader width={"100%"}
                  height={"100%"}
                  viewBox="0 0 1500 400"
                  backgroundColor="#f3f3f3"
                  foregroundColor="#ecebeb"
                  speed={5} >
                     {/* Columnas de la tabla */}
                    <rect x="0%" y="139" rx="4" ry="4" width="5%" height="20" />
                    <rect x="7%" y="140" rx="10" ry="10" width="35%" height="19" />
                    <rect x="44%" y="141" rx="10" ry="10" width="25%" height="19" />
                    <rect x="72%" y="142" rx="10" ry="10" width="12%" height="19" />
                    <rect x="86%" y="143" rx="10" ry="10" width="12%" height="19" />
    
                    <rect x="0%" y="196" rx="4" ry="4" width="5%" height="20" />
                    <rect x="7%" y="197" rx="10" ry="10" width="35%" height="19" />
                    <rect x="44%" y="198" rx="10" ry="10" width="25%" height="19" />
                    <rect x="72%" y="197" rx="10" ry="10" width="12%" height="19" />
                    <rect x="86%" y="198" rx="10" ry="10" width="12%" height="19" />
                
                    <rect x="0%" y="258" rx="4" ry="4" width="5%" height="20" />
                    <rect x="7%" y="259" rx="10" ry="10" width="35%" height="19" />
                    <rect x="44%" y="260" rx="10" ry="10" width="25%" height="19" />
                    <rect x="72%" y="259" rx="10" ry="10" width="12%" height="19" />
                    <rect x="86%" y="260" rx="10" ry="10" width="12%" height="19" />
                
                    <rect x="0%" y="316" rx="4" ry="4" width="5%" height="20" />
                    <rect x="7%" y="317" rx="10" ry="10" width="35%" height="19" />
                    <rect x="44%" y="318" rx="10" ry="10" width="25%" height="19" />
                    <rect x="72%" y="317" rx="10" ry="10" width="12%" height="19" />
                    <rect x="86%" y="318" rx="10" ry="10" width="12%" height="19" />
                </ContentLoader>
              </div>
            ) : (
              <div className="flex flex-col items-start justify-center w-full pb-8 pt-28">
                <h1 className=" text-[32px] text-blue font-itcbold text-center lg:text-left">Productos</h1>
                <div className="flex flex-col justify-between w-full gap-3 ">
                  <div className="md:flex items-center sm:justify-between">
                    <div className="flex sm:justify-between gap-3 my-4"> 
                      <FilterInput
                        placeholder="Filtrar por producto"
                        value={product}
                        onChange={(e) =>  handleFilterByProduct(e.target.value)}
                      />
                      <FilterButton
                        text="Filtrar por Categoría"
                        options={categoria}
                        onSelect={handleFilterByCategoria}
                        selectedOption={selectedCategory}
                      />
    
                    </div>
                    <SearchInput 
                      placeholder='Buscar' 
                      value={searchTerm}
                      onChange={handleSearch}
                    />
                  </div>
                  
                  <div className="sm:flex items-center justify-between space-y-3 sm:space-y-0">
                    <button
                      onClick={openModalAddProduct}
                      className="flex items-center justify-center h-[40px] p-3 px-5 space-x-4 text-white rounded-md bg-green"
                    >
                      <RiAddFill className="flex text-[14px] font-itcmedium" /> 
                        Agregar producto
                    </button>
                    <div className="flex items-center justify-between gap-2">
                      <ResetFiltersButton onClick={handleResetFilters}/>
                      <ExportButton onClick={handleExportToExcel} disabled={isExportDisabled} /> 
                    </div> 
                  </div>
    
                </div>
                <div className="flex flex-col-reverse items-start w-full mb-4 space-y-2 md:items-center md:justify-between md:flex-row ">
                  {/** 
                  <div className="flex items-center justify-center pt-4 space-x-2 md:pt-0">
                    <p className="text-sm text-[#76A140] font-itcbook">Mostrar</p>
                    <div className=" border-[#76A140] border-[1px] rounded-md w-[58px] flex justify-center items-center h-[40px]">
                      <select
                        className="text-sm text-[#76A140] font-itcbook px-2 w-full h-full bg-white rounded-md outline-none"
                        id="recordsPerPage"
                        value={currentRecordsCount}
                        onChange={handleRecordsCountChange}
                      >
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                      </select>
                    </div>
                    <p className="text-sm text-[#76A140] font-itcbook">Registros</p>
                  </div>
                  */}
      
                
                </div>
                
                <TableProduct
                  data={records} 
                  filterCategory={selectedCategory}
                  onFilterCategoryChange={setSelectedCategory} 
                  filterProduct={product} 
                  onFilterProductChange={setProduct}
                  filterCode={codeProduct} 
                  onFilterCodetChange={setCodeProduct}
                  recordsPerPage={currentRecordsCount}
                  currentPage={currentPage} 
                  setCurrentPage={setCurrentPage} 
                  searchTerm={searchTerm}
                  onSearchTermChange={handleSearch}
                  showModalAddProduct={showModalAddProduct}
                  closeModalAddProduct={closeModalAddProduct}
                />
              </div>  
            )}
          </div>
          <Programate/>
        </div>
      </div>
    </div>
  );
}